import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchListings = (params = {}) => api.get("/listings", { params }).then(r => r.data);
export const fetchListing = (id) => api.get(`/listings/${id}`).then(r => r.data);
export const createListing = (data) => api.post("/listings", data).then(r => r.data);
export const fetchStats = () => api.get("/stats").then(r => r.data);
export const joinWaitlist = (data) => api.post("/waitlist", data).then(r => r.data);
export const sendContact = (data) => api.post("/contact", data).then(r => r.data);
export const requestListingContact = (id, data) => api.post(`/listings/${id}/contact`, data).then(r => r.data);
export const sendMessage = (data) => api.post("/messages", data).then(r => r.data);
export const getThread = (tid) => api.get(`/messages/${tid}`).then(r => r.data);
export const getUserThreads = (email) => api.get(`/threads/${email}`).then(r => r.data);
export const saveListing = (data) => api.post("/saved", data).then(r => r.data);
export const getSaved = (email) => api.get(`/saved/${email}`).then(r => r.data);

export async function streamAI(path, body, onToken, onDone, onError) {
  try {
    const res = await fetch(`${API}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!res.ok || !res.body) {
      onError?.(new Error("Stream failed"));
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop() || "";
      for (const line of lines) {
        if (!line.startsWith("data: ")) continue;
        const data = line.slice(6);
        if (data === "[DONE]") { onDone?.(); return; }
        if (data.startsWith("[ERROR]")) { onError?.(new Error(data)); return; }
        onToken?.(data);
      }
    }
    onDone?.();
  } catch (e) { onError?.(e); }
}
